module.exports = __webpack_public_path__ + "img/task.43b3d62b.svg";